import Jumbotron from "react-bootstrap/Jumbotron";

const Header = () => {
    
return (
<Jumbotron fluid className="p-5 hero-text">
  <h1>Employee Directory</h1>
  <p>
    Search hundreds of talented prospects waiting to connect today.
  </p>
</Jumbotron>

)

};

export default Header;